import { sheet } from '../state/sheet';
import { selectedId, pushToast } from './uiState';
import { SheetSVG } from './SheetSVG';
import { replaceSlotImage, uploadFiles } from '../state/actions';

const REJECT_TEXT: Record<'unsupported-type' | 'load-failed', string> = {
  'unsupported-type': 'unsupported format',
  'load-failed': 'failed to read',
};

export function SheetPreview() {
  let inputRef!: HTMLInputElement;
  let pendingSlotId: number | null = null;

  function onSlotClick(id: number) {
    pendingSlotId = id;
    inputRef.click();
  }

  async function onPick(e: Event) {
    const input = e.currentTarget as HTMLInputElement;
    // Snapshot the FileList into a stable array BEFORE resetting input.value.
    // Setting value = '' empties the live FileList in place, so reading it
    // afterwards yields an empty array. This was the bug behind "tap circle,
    // pick file, nothing happens".
    const fileList = input.files ? Array.from(input.files) : [];
    input.value = '';
    if (fileList.length === 0 || pendingSlotId === null) {
      pendingSlotId = null;
      return;
    }
    const startId = pendingSlotId;
    pendingSlotId = null;

    // First file → the slot the user tapped on (replaces existing image).
    const first = await replaceSlotImage(startId, fileList[0]!);
    if (!first.ok) {
      pushToast({ kind: 'error', text: `${first.filename}: ${REJECT_TEXT[first.reason]}` });
    }
    // Remaining files → distribute via standard upload (fills from first empty).
    if (fileList.length > 1) {
      const outcome = await uploadFiles(fileList.slice(1));
      for (const name of outcome.rejectedFilenames) {
        const reason = outcome.rejectedReasons[name] ?? 'load-failed';
        pushToast({ kind: 'error', text: `${name}: ${REJECT_TEXT[reason]}` });
      }
      if (outcome.skippedFilenames.length > 0) {
        pushToast({
          kind: 'info',
          text: `Sheet is full, did not fit: ${outcome.skippedFilenames.join(', ')}`,
        });
      }
    }
  }

  return (
    <div class="sheet-preview">
      <input
        ref={inputRef}
        type="file"
        multiple
        accept="image/jpeg,image/png,image/svg+xml"
        hidden
        onChange={onPick}
      />
      <SheetSVG
        slots={sheet.slots}
        highlightId={selectedId()}
        onSlotClick={onSlotClick}
      />
    </div>
  );
}
